import { type RgbColorHex, SharedUiColorsService } from '@/shared/ui/theming';
import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import type { Observable } from 'rxjs';
import { EllipsisWithTitleFallbackDirective } from '../../../directives/ellipsis-with-title-fallback/ellipsis-with-title-fallback.directive';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./widget-catalog-item.scss'],
    selector: 'widget-catalog-item',
    templateUrl: 'widget-catalog-item.html',
    imports: [SvgIconComponent, EllipsisWithTitleFallbackDirective, AsyncPipe, TranslatePipe]
})
export class WidgetCatalogItemComponent {
    private _colorsService = inject(SharedUiColorsService);

    @Input() title!: string;
    @Input() label: string = '';
    @Input() thumbnailImg: string | null = null;

    defaultImage: string = 'https://cdn.advizeo.io/img/widgets/default-thumbnail.png';
    defaultFillerColor$!: Observable<RgbColorHex>;

    ngOnInit() {
        this.defaultFillerColor$ = this._colorsService.getTextColor$();
    }
}
